<template>
    <article class="cmp cmp-product-thumb" ref="article" :data-testing="item.variation.id">
        <div :class="paddingClasses" :style="paddingInlineStyles">

            <div class="thumb-image">
                <div class="prop-1-1">
                    <slot name="item-image">
                        <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                :alt="item | itemName"
                                                :title="item | itemName"
                                                :item-url="item | itemURL(urlWithVariationId)"
                                                :enable-carousel="false"
                                                :disable-carousel-on-mobile="true"
                                                ref="categoryImageCarousel">
                        </category-image-carousel>
                    </slot>
                </div>
            </div>

            <!-- STORE SPECIALS -->
            <slot name="store-special">
                <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                    :store-special="storeSpecial"
                                    :recommended-retail-price="item.prices.rrp"
                                    :variation-retail-price="item.prices.default"
                                    :special-offer-price="item.prices.specialOffer"
                                    :decimal-count="decimalCount"
                                    :bundle-type="item.variation.bundleType"
                                    :item-type="item.item.itemType"></item-store-special>
            </slot>
            <!-- ./STORE SPECIALS -->

            <!-- ITEM DETAILS -->
            <slot name="item-details">
                <div class="thumb-content">
                    <div class="category-item__color-wrapper">
                        <div class="category-item__colors" v-if="item.item.salableVariationCount > 1">{{ $translate("ODStylebreaker::Template.color") }}
                            <div class="category-item__color-icon">
                                <div class="category-item__part category-item__part--1"></div>
                                <div class="category-item__part category-item__part--2"></div>
                                <div class="category-item__part category-item__part--3"></div>
                            </div>
                        </div>
                    </div>

                    <hr class="thumb-content__hr">

                    <div class="thumb-content__txt">
                        <a :href="item | itemURL(urlWithVariationId)" class="thumb-title small">
                            {{ item.texts.name2 }}<!--
                    --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                        </a>
                        <div class="thumb-meta mt-2">
                            <slot name="before-prices"></slot>

                            <div class="prices">
                                <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value" class="price-view-port">
                                    <del class="crossprice" v-if="item.prices.specialOffer">
                                        {{ item.prices.default.unitPrice.formatted }}
                                    </del>
                                    <del class="crossprice" v-else>
                                        {{ item.prices.rrp.unitPrice.formatted }}
                                    </del>
                                </div>

                                <div class="price">
                                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                                </div>
                            </div>
                        </div>
                    </div>



                    <slot name="after-prices"></slot>

                    <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
                        <span>{{ item.unit.content }}</span>
                        <span>&nbsp;{{ item.unit.names.name }}</span>
                        <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
                    </div>

                    <span class="vat small text-muted">
                    * <span v-if="showNetPrices">{{ $translate("Ceres::Template.itemExclVAT") }}</span>
                    <span v-else>{{ $translate("Ceres::Template.itemInclVAT") }}</span>
                    {{ $translate("Ceres::Template.itemExclusive") }}
                    <a v-if="$ceres.config.global.hasShippingCostsCategoryId > 0" data-toggle="modal" href="#shippingscosts" class="text-appearance" :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                    <a v-else :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                </span>
                </div>
            </slot>
            <!-- ./ITEM DETAILS  -->
        </div>
        <div class="category-item__hover category-item__hover--wishlist">
            <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
        </div>
        <div class="category-item__hover category-item__hover--quickview" :class="{'cursor-not-allowed' : isLoadingVariations}">
            <a href="#" @click.prevent="loadVariationImages()">
                <i v-if="!isLoadingVariations" class="icon-view"></i>
                <i v-else class="fa fa-spinner"></i>
                <span>{{ $translate("ODStylebreaker::Template.quickView") }}</span>
            </a>
        </div>


        <div class="category-item__quick-view-item-modal" v-show="showItemModal" ref="quickViewModal">
            <button type="button" class="search-autocomplete__close btn-close" @click="closeItemQuickView()">
                ×
            </button>
            <!-- itemimagecarousel -->
            <div class="category-item__quick-view-item-image" v-if="showItemModal">
                <item-image-carousel
                        :max-quantity="8"
                        image-url-accessor="urlMiddle"
                        :show-thumbs="true"
                        :show-dots="false"
                        animation-style=""
                        :enable-lightbox="false"
                        :plugin-path="pluginPath"
                        :category-item-data="item">
                </item-image-carousel>
            </div>
            <div class="category-item__quick-view-info" v-if="showItemModal">
                <div class="category-item__quick-view-headline">{{ item.texts.name2 }}</div>
                <div class="category-item__quick-view-price-wrapper">
                    <span class="category-item__quick-view-price">
<!--                        {{ item.prices.default.price.formatted }}*-->


                            <div class="prices">
                                <div class="price" :class="{'crossprice-color' : item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value}">
                                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                                </div>
                                <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value" class="price-view-port ml-1">
                                    <del class="crossprice" v-if="item.prices.specialOffer">
                                        {{ item.prices.default.unitPrice.formatted }}
                                    </del>
                                    <del class="crossprice" v-else>
                                        {{ item.prices.rrp.unitPrice.formatted }}
                                    </del>
                                </div>
                            </div>
                    </span>
                    <span class="category-item__quick-view-txt category-item__quick-view-txt--after-price">&nbsp;&nbsp;&nbsp;&nbsp;inkl. MwSt., zzgl. <a href="/zahlung-und-versand" title="Versand">Versand</a></span>
                </div>
                <div class="category-item__quick-view-txt">Artikelnummer:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.variation.number }}</div>
                <div class="category-item__quick-view-details">
                    <a :href="item | itemURL(urlWithVariationId)" :title="item.texts.name2">Artikeldetails</a>
                </div>

                <hr>

                <div v-if="attributesMap.length">
                    <variation-select-category :attributes="attributesMap"
                                               :variations="variationsMap"
                                               :item-variations="variations"
                                               :variation-id="item.variation.id"
                                               :selected-variation="item" v-on:childToParent="onChildClick">
                    </variation-select-category>
                </div>
            </div>
            <div class="category-item__quick-view-basket-row" v-if="showItemModal">
                <div class="category-item__quick-view-basket-col--left" >
                    <variation-select-category v-if="attributesMap"
                                               :attributes="attributesMap"
                                               :variations="variationsMap"
                                               :item-variations="variations"
                                               :variation-id="item.variation.id"
                                               :selected-variation="item"
                                               :is-size="true"
                    ></variation-select-category>

                </div>
                <div class="category-item__quick-view-basket-col--right">
                    <QuantityInput
                            :value="qty"
                            @quantity-change="updateQty"
                    />
                </div>
                <div class="category-item__quick-view-basket-col--left od-wishlist">
                    <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
                </div>
                <div class="category-item__quick-view-basket-col--right">
                    <add-to-basket v-if="item"
                                   :variation-id="item.variation.id"
                                   :item-id-category="item.item.id"
                                   :is-salable="!!item.filter && item.filter.isSalable"
                                   :has-children="!!item.filter && item.filter.hasActiveChildren"
                                   :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                   :minimum-quantity="item.variation.minimumOrderQuantity"
                                   :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                   :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                   :has-order-properties="item.hasOrderProperties"
                                   :use-large-scale="false"
                                   :show-quantity="false"
                                   :item-url="item | itemURL"
                                   :has-price="item | hasItemDefaultPrice"
                                   :propQuantity="qty"
                    >
                    </add-to-basket>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import ApiService from "ceres/app/services/ApiService";
import QuantityInput from "../item/QuantityInput.vue"

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial,
        QuantityInput
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlSecondPreview" // muss wieder auf middle, da preview nicht verwendet werden soll (nur für dokumente), und secondPreview für die ganz kleinen bilder
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    mounted()
    {
        this.currentUrl = window.location.href;

        this.$nextTick(() =>
        {
            // this.loadVariationImages();
            this.initialItemId = this.item.item.id;
        });
    },

    data(){
        return {
            variations: {},
            variationsMap: [],
            isLoadingVariations: false,
            showItemModal: false,
            pluginPath: App.pluginPath,
            attributesMap: [],
            initialItemId: 0,
            qty:1,
            currentUrl: "",
            changeFromVariationSelect: false,
            overlayItem: undefined
        }
    },

    methods:{
        onChildClick (value) {
            this.changeFromVariationSelect = true
        },

        setAttributes(){
            if(Object.keys(this.attributesMap).length === 0){
                let usedAttributes = [];
                let usedValues = [];

                function getKeyByValue(object, value) {
                    return Object.keys(object).find(keyInner => object[keyInner] === value);
                }

                for(let key in this.variations){
                    let varData = this.variations[key].documents[0].data.attributes;

                    for(let keyKey in varData){
                        if(usedAttributes.includes(varData[keyKey].attributeId)){
                            // attr id ist schon in der map, valuesmuss erweitert werden
                            let arrKey = getKeyByValue(usedAttributes, varData[keyKey].attributeId);

                            if(!usedValues.includes(varData[keyKey].value.id)){

                                usedValues.push(varData[keyKey].value.id);

                                this.attributesMap[arrKey].values.push({
                                    attributeValueId: varData[keyKey].value.id,
                                    imageUrl: this.variations[key].bigImage,
                                    name: varData[keyKey].value.names.name,
                                    position: varData[keyKey].value.position,
                                });
                            }

                        }else{
                            usedAttributes.push(varData[keyKey].attributeId);

                            this.attributesMap.push({
                                attributeId: varData[keyKey].attributeId,
                                name: varData[keyKey].attribute.names.name,
                                position: varData[keyKey].attribute.position,
                                type: varData[keyKey].attribute.typeOfSelectionInOnlineStore,
                                values: []
                            });

                            if(!usedValues.includes(varData[keyKey].value.id)){

                                usedValues.push(varData[keyKey].value.id);

                                this.attributesMap[keyKey].values.push({
                                    attributeValueId: varData[keyKey].value.id,
                                    imageUrl: this.variations[keyKey].bigImage,
                                    name: varData[keyKey].value.names.name,
                                    position: varData[keyKey].value.position,
                                });
                            }

                        }
                    }
                }
            }
        },

        closeItemQuickView(){
            $(this.$refs.quickViewModal).detach().appendTo(this.$refs.article);
            this.showItemModal = false;
            $('body').removeClass("quick-view-open");
            $('.modal-backdrop').remove();

            window.history.pushState("object or string", "Title", this.currentUrl);
        },

        orderByPosition(list)
        {
            return list.sort(
                (entryA, entryB) =>
                {
                    if (entryA.position > entryB.position)
                    {
                        return 1;
                    }
                    if (entryA.position < entryB.position)
                    {
                        return -1;
                    }

                    return 0;
                });
        },

        loadVariationImages(){

            this.isLoadingVariations = true;

            ApiService.get("/rest/stylebreaker/itemlist?itemId="+ this.item.item.id)
                .done(data => {

                    this.variations = data.itemList;
                    this.variationsMap = data.variationsMap;

                    for(let key in this.variations){
                        let previewImages = this.orderByPosition(this.$options.filters.itemImages(
                            this.variations[key].documents[0].data.images,
                            "urlPreview"
                        )).slice(0, 1);

                        this.variations[key].previewImage = previewImages[0];

                        let bigImages = this.orderByPosition(this.$options.filters.itemImages(
                            this.variations[key].documents[0].data.images,
                            "urlMiddle"
                        )).slice(0, 1);

                        this.variations[key].bigImage = bigImages[0];
                    }

                    // anpassen des variationsArrays
                    let vars = this.variations;
                    let newVars = [];
                    let colorValueIdsUsed = []; // wenn id 5 oder 12 ist, valueIds reinschreiben
                    for(let key in vars){
                        for(let innerKey in vars[key].documents[0].data.attributes){
                            if([5, 12].indexOf(vars[key].documents[0].data.attributes[innerKey].attributeId) > -1){
                                if(colorValueIdsUsed.indexOf(vars[key].documents[0].data.attributes[innerKey].valueId) < 0){
                                    newVars.push(vars[key]);
                                    colorValueIdsUsed.push(vars[key].documents[0].data.attributes[innerKey].valueId)
                                }
                            }
                        }
                    }

                    this.variations = newVars;

                    this.$nextTick(() =>
                    {
                        this.isLoadingVariations = false;
                        this.setAttributes();

                        this.showItemModal = true;
                        $(this.$refs.quickViewModal).detach().appendTo('body');
                        $('body').addClass("quick-view-open");
                        $('body').append("<div class='modal-backdrop'></div>");
                    });

                }).fail((err)=> console.log(err));
        },

        mouseOverThumbImage(event){ // $event.target
            let img = $(event).attr('image');
            $(event).closest('article').find('.thumb-image img').attr('src', img);
            $(event).closest('article').find('.thumb-image picture source').attr('srcset', img);
        },

        updateQty(num){
            this.qty = num;
        }

    },

    computed:
    {

        item()
        {
            if(typeof this.overlayItem !== 'undefined' && Object.keys(this.overlayItem).length && this.overlayItem.item.id == this.initialItemId){
                return this.overlayItem;
            }
            return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices,
        })
    },

    watch:{
        changeFromVariationSelect(value){
            if(value){
                this.overlayItem = this.$store.state.items[this.initialItemId].variationSelect.overlayItem;
                this.changeFromVariationSelect = false;
            }
        }
    }
}
</script>
